import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import TabsEditDisplay from 'formiojs/components/tabs/editForm/Tabs.edit.display';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: TabsEditDisplay,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 100,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
        {
          weight: 150,
          type: 'textfield',
          label: 'Tooltip',
          key: 'tooltip',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
